import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ScheduledMeetings from "./meetings";
import { getMeetingLists } from "services/redux/brandActivtion/meetings/action";

import {
  getSiteFilters,
} from 'services/redux/brandActivtion/sitesListing/action';

const mapStateToProps = (state) => ({
  meetingList: state.baMeetingReducer.meetingList,
  siteFilters: state.baSiteListingReducer.siteFiltersData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMeetingLists,
      getSiteFilters,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledMeetings);
